import { del } from "vue";

export default {
  button: {
    edit: 'Edit',
    modify: 'Modify',
    return: 'Return',
    add: 'Add',
    addBan: 'Add Banned Account',
    del: 'Delete',
    authorization: 'Authorization',
    secret: 'Modify Google Secret',
    resetSecret: 'Reset Google Secret',
    delMessage: 'Are you sure to delete it?',
    modifyMessage: 'Are you sure about the modification?',
    cancel: 'no',
    confirm: 'yes',
    save: 'Save',
    ordinary: 'Ordinary version',
    speed: 'Speed version',
    batchNotify: 'Batch notify',
    empty: 'Empty',
    close: 'Close',
    jump: 'Yes, jump to page',
    query: 'Query',
    jumpMerchant: 'Jump',
    config: 'Config',
    breaker: 'Close Warning',
    refresh: 'Clear Cache',
    share: 'Share',
    version: 'Historic Version',
    sendMes: 'Send Message',
    batchCollect: 'Batch Collect',
    productConfig: 'Cashier',
    sendGroupMes: 'Set Send Group Message',
    submit: 'Submit',
    setTimeZone: 'Set Currency Timezone',
    UnderstandProduct: 'Understand the product',
    delImg: 'Delete Image',
    preview: 'Preview Picture',
    clearCount: 'Clear Count',
    info: 'Info',
    reset: 'Reset Robot',
    bind: 'Bind Robot',
    copy: 'Copy',
    upload: 'Upload',
    refund: 'One-Click Refund',
    export: 'Transaction Export',
    notification: 'One-click notification',
    configuration: 'Modify Configuration',
    detele: 'Delete Custom',
    rate: 'Settlement Amount Rate',
    type: 'Settlement Type',
    cycle: 'Settlement Cycle',
    time: 'Time Unit',
    batchReview: 'Batch Review',
    start: 'Open',
    none: 'None',
    sig: 'multi sig',
    callback: 'Call Back',
    Deprecated: 'Cancel',
    batchDisable: 'Batch Stop',
    batchRestart: 'Batch Restart',
    invert: 'Filter merchant account',
    newRate: 'New Fee',
    subFee: 'Fee Details',
    refund1: 'Refund',
    rolling: 'Revolving margin'

  },
  batch: {
    limitRange: 'Limit Range',
    min_amount: 'Min Amount',
    max_amount: 'max_amount',
    batchEdit: 'Batch Edit',
    limited: 'Daily limited trading',
    del: 'Batch delete',
    delAccounts: 'Account Name',
    description: 'Description',
    googleCode: 'Google Code',
    allNotice:
      'Notify all accounts within the current product, please proceed with caution',
    refund: 'Batch refund',
    errList: 'List of refund failed orders',
    msg: 'error description',
    enable: 'Batch start',
    errText: 'Batch payment for up to 200 orders',
    checkUpload: 'Please check the available time for editing'
  },
  endMessage: {
    send: 'Send Group Message',
    group: 'Telegram Group',
    tGroup: 'Group',
    text: 'Text',
    photo: 'Photo',
    video: 'Video',
    upload: 'Upload Photo',
    select: 'Message Type',
    textArea: 'Message Content',
    all: 'Check All',
    groupSearch: 'Enter a group type to query a group',
    boundGroup: 'Bound Group',
    management: 'Management',
    groupList: 'Group List',
    groupName: 'Group Name',
    groupId: 'Group ID',
    forward_chat_id: 'Forward Chat ID',
    forward_extra_text: 'Forward Extra Text',
    permission: 'Group Message Permission',
    deactivate: 'Deactivate',
    information: 'Edit Group Information',
    bot_type: 'Invoice Type',
    deleteVideo: 'Delete Video',
    classification: 'Group Classification',
    classify: 'Classification',
    name: 'Classification Name',
    description: 'Classification Description',
    Send: 'Send',
    addType: 'Add Group Classification',
    editType: 'Edit Group Classification',
    comds: 'Order',
    order_list: 'Order List',
    default: 'Default',
    defined: 'Defined',
    confirm: 'Confirm Edit'
  },
  time: {
    halfhHour: 'Half Hour',
    oneHour: 'One Hour',
    fourHour: 'Four Hour',
    yesterday: 'Yesterday',
    lastMonth: 'Last Month',
    aWeek: 'One Week',
    aMonth: 'One Month',
    threeMonths: 'Three Months',
    ipRemind: 'Each input box can only input one IP, multiple IPs are invalid!',
    five: 'Five Minutes',
    ten: 'Ten Minutes'
  },
  jump: {
    jump: 'Do you need to jump to the H5 background page?'
  },
  page: {
    prev: 'prev',
    next: 'next'
  },
  upload: {
    tips: 'Drag the file here'
  },
  tag: {
    approve: 'Approve',
    reject: 'Reject',
    wait: 'Pending'
  },
  table: {
    username: 'Username',
    password: 'Password',
    email: 'Email',
    ip_whiteList: 'IP WhiteList',
    task_description: 'Task Description',
    manager_type: 'Manager Type',
    total: 'Total',
    successful_volume: 'Succeed Request Amount',
    successful_ransaction: 'Succeed Paid Amount',
    success_amount: 'Success Amount',
    pending_amount: 'Pending Amount',
    pending_transaction: 'Pending Transaction',
    approval_amount: 'Approval Amount',
    approval_transaction: 'Approval Transaction',
    reject_amount: 'Reject Amount',
    reject_transaction: 'Reject Transaction',
    transaction: 'Transaction',
    volume: 'Volume',
    dealVolume: 'Volume',
    successful_rate: 'Successful Rate',
    today: 'Today',
    notify_status: 'Notify Status',
    product_name: 'Product Name',
    product_code: 'Product',
    product_account: 'Product Account',
    min_amount: 'Min Amount',
    max_amount: 'Max Amount',
    notify_time: 'Notify Time',
    notify_start_time: 'Notify Start Time',
    notify_end_time: 'Notify End Time',
    source: 'Source',
    backoffice_payout: 'Backoffice Payout',
    id: 'ID',
    currency: 'Currency',
    merchant_ref: 'Merchant Ref',
    systemRef: 'System Ref',
    system_ref: 'System Ref',
    requset_amount: 'Requset Amount',
    paid_amount: 'Paid Amount',
    product: 'Product',
    order_status: 'Order Status',
    upstream_ordernumber: 'Product Ref',
    title: 'Title',
    description: 'Description',
    bank: 'Bank',
    remarks: 'Remarks',
    reason: 'Reason',
    order_number: 'Order Number',
    account_name: 'Account Name',
    account_no: 'Account No',
    status: 'Status',
    platformStatus: 'Status',
    taskStatus: 'Status',
    created_start_time: 'Created Start Time',
    created_end_time: 'Created End Time',
    insruction: 'Insruction',
    bank_name: 'Bank Name',
    bank_code: 'Bank Code',
    amount: 'Amount',
    fee: 'Fee',
    approved_by: 'Approved By',
    approved_time: 'Approved time',
    created_by: 'Created By',
    created_time: 'Created time',
    operation: 'Operation',
    extend_params: 'Extend Params',
    information: 'Information',
    cause: 'Cause',
    before_balance: 'Before Balance',
    after_balance: 'After Balance',
    sourceIP: 'Source IP',
    date: 'Date',
    merchant_no: 'Merchant No',
    merchant_name: 'Merchant Name',
    begin_balance: 'Opening Balance',
    end_balance: 'Ending Balance',
    startingBalance: 'Starting Pending Balance',
    endingBalance: 'Ending Pending Balance',
    type: 'Type',
    dealType: 'Type',
    change_amount: 'Manual Intervention Volume',
    change_transaction: 'Manual Intervention Transaction',
    product_type: 'Product Type',
    settlementLimit: 'Settlement Limit',
    transitionLimit: 'Transition Limit',
    transitionTime: 'Transition Time',
    notify: 'Notify',
    details: 'Details',
    agentFee: 'Agent Fee',
    agentNo: 'Agent No',
    commission: 'Commission',
    success_transaction: 'Success Transaction',
    review: 'Review',
    address: 'Address',
    coin_type: 'Coin Type',
    expectStatus: 'Expect Status',
    attach: 'Attach',
    success_time: 'Success time',
    success_start_time: 'Success Start Time',
    success_end_time: ' Success End Time',
    succeedRequestAmount: 'Succeed Request Amount',
    succeedVolume: 'Succeed Volume',
    succeedPaidAmount: 'Succeed Paid Amount',
    conversionRate: 'Conversion Rate',
    mode: 'Processing Mode',
    placeholder: 'Fill in the reasons and review them',
    smsLink: 'Download SMS Forwarder',
    plugin_name: 'Plugin Name',
    lastest_version: 'Plugin Version',
    download_link: 'Download Link',
    version: 'Version',
    renew: 'Version Updates',
    reuse_address: 'Reuse Deposit Address',
    reuse_address_days: 'Days',
    not_reuse_address: 'Merchant Not Reuse Address',
    reuse_address_count: 'Reuse Address Count',
    collect_by_stake: 'Pledge Collection',
    pledgeType: 'Pledge Type',
    pledgeAccount: 'Pledge Account',
    pledgeAddress: 'Pledge Address',
    path: 'Path',
    name: 'Checkout Counter Name',
    between: 'Number of days between',
    sort: 'Serial Number',
    sort_L: 'Sort',
    noData: 'No Data',
    reuse_upstream_accounts: 'Reuse upstream accounts frequency',
    walletName: 'Wallet Name',
    rakeBack: 'Same day commission rebate',
    login_ip: 'Login IP',
    recharge_address: 'Recharge Address'
  },
  checkbox: {
    checkAll: 'Select All'
  },
  tips: {
    tips: 'Tips：',
    batchPaid: 'Only pending orders can be paid',
    batchChange: 'Only pending orders can be change',
    batchUnfreeze: 'Only freeze orders can be unfreeze',
    batchNotify: 'Only not notified orders can be notified',
    currentSystem: 'The total pending orders of the current system',
    kick: 'Only orders in queue can be kicked out of the queue',
    path: 'The current product cannot configure cashier routing',
    apikeyshow:
      'The API key has been modified, please keep it safe and do not disclose it to others.',
    search: 'Mobile phone number, username search for account'
  },
  route: {
    adminMgt: 'Manager',
    adminList: 'Admin List',
    log: 'Log',
    loginLog: 'Login Log',
    accessDevice: 'Access Device',

    test: 'Test Center',
    setting: 'System Setting',
    download: 'Download Center',
    appSoftware: 'Channel Market',

    taskCenter: 'Task Center',
    applicationTask: 'Admin Task',
    banAccount: 'Account suspension',
    withdrawReview: 'Withdraw Review',
    antOrderReview: 'Ant Grab Order Review',
    depositReview: 'Deposit Review',
    exceptionTask: 'Abnormal Order ',
    bankBill: 'Bank Statement',
    upstreamBill: 'Upstream Bill',
    rechargeCurrency: 'Recharge Currency',
    subAccount: 'Sub Account',
    smsAccount: 'SMS Account',
    cardAccount: 'Card Account',
    antReview: 'USDT-TRCPayout Review',
    smsManage: 'Merchant SMS',
    antRegister: 'Registration Approval',

    product: 'Product Manage',
    productManage: 'Product List',
    accountManage: 'Account List',
    walletAddress: 'Wallet Address',
    accountGroup: 'Account Group',
    antAccountGroup: 'Ant Account Group',
    smsLog: 'SMS Log',

    merchantMgt: 'Merchant Manage',
    merchantList: 'Merchant List',

    orderMgt: 'Order Manage',
    deposit: 'Deposit Order',
    payout: 'Payout Order',
    settlement: 'Settlement Order',
    refund: 'Refund Order',
    requestLog: 'Request Log',
    globalPayments: 'Global Payments',

    report: 'Report Center',
    balance: 'Balance Report',
    transaction: 'Transaction Report',
    rebate: 'Rebate report',
    platform: 'Platform report',
    upparting: 'Robot Upparting',
    agent: 'Agency commission',

    dashboard: 'Dashboard',
    backToTop: 'Back To Top',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    theme: 'Theme',
    profile: 'Profile',
    antDashboard: 'Dashboard',
    antManage: 'Ant Manage',
    topupOrder: 'Topup Order',
    cashOrder: 'Withdraw Order',
    buyUOrder: 'Buy U Order',
    shopManage: 'Merchant Management',
    operateManage: 'Operation Manage',
    goodsManage: 'Product Manage',
    operation: 'Operation Center',
    gcash: 'Gcash Manage',
    gcashAccount: 'Gcash Account',
    gcashGroups: 'Gcash Groups',
    exchangeOrder: 'Exchange Order'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    size: 'Global Size',
    return: 'Application Panel'
  },
  login: {
    title: 'Login Form',
    logIn: 'Login',
    username: 'Username',
    password: 'Password',
    code: 'Please enter a verification code',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips:
      'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  admin: {
    ip: 'The 0.0.0.0 means no limit is set.',
    password: 'Output if modified, otherwise no input is required',
    authMgt: 'Authorization management',
    module: 'Module',
    menu: 'Menu',
    function: ' Function',
    example: 'Example'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    showTagsView: 'Open Tags-View',
    showSidebarLogo: 'Sidebar Logo',
    fixedHeader: 'Fixed Header',
    sidebarTextTheme: 'Sidebar Text Theme'
  },
  task: {
    applicationTask: {
      created_by_name: 'Ceator',
      approved_by_name: 'Verifier',
      time: 'Time',
      start_time: 'Start time',
      end_time: 'End time',
      handle_time: 'Responese time',
      begin_handle_time: 'Initial response time',
      end_handle_time: 'Termination response time',
      status: 'Review the status',
      status0: 'Await audit',
      status1: 'Approval',
      status2: 'Reject'
    }
  },
  // ------------- 新翻译 -------------
  loginPage: {
    loginForm: 'Login Form',
    username: 'Email',
    password: 'Password',
    code: 'Google',
    logIn: 'Login',
    thirdparty: 'Or connect with',
    thirdpartyTips:
      'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  application: {
    applicationPanel: 'Application Panel',
    myApplication: 'My Application',
    addApplication: ' Add Application',
    describe1: 'Can create',
    describe2: 'apps',
    describe3: 'more',
    logOut: 'Log Out',
    edit: 'Edit',
    apps: 'apps',
    applicationName: 'Application Name',
    holder: 'Please enter the Application Name',
    status: 'Status',
    availableCurrency: 'Available Currency',
    close: 'Close',
    create: 'Create',
    save: 'Save',
    editApplication: 'Edit Application',
    type: 'Enterprise Type',
    payment: 'Payment',
    ant: 'Ant'
  },
  header: {
    currentApplication: 'Current Application',
    currentTime: 'Current Time',
    currentUser: 'Current User'
  },
  dashboard: {
    sort: 'Sort',
    merchantNo: 'Merchant No',
    productName: 'Product Name',
    productAccount: 'Product Account',
    select: 'select',
    reset: 'reset',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    settlement: 'Settlement',
    balance: 'Balance',
    abnormalOperation: 'Abnormal Operation',
    amount: 'Amount',
    volume: 'Volume',
    fee: 'Fee',
    pendingPayoutAmount: 'Pending Payout Amount',
    succeededPayoutAmount: 'Succeeded Payout Amount',
    payoutFee: 'Payout Fee',
    pendingSettlementAmount: 'Pending Settlement Amount',
    succeededSettlementAmount: 'Succeeded Settlement Amount',
    settlementFee: 'Settlement Fee',
    pending_refund_amount: 'Pending Refund Amount',
    succeed_refund_amount: 'Succeed Refund Amount',
    refund_fee: 'Refund Fee',
    change_refund_order_amount: 'Change Refund Order',
    totalAmount: 'Total Amount',
    succeededAmount: 'Succeeded Amount',
    totalTransaction: 'Total Transaction',
    succeededTransaction: 'Succeeded Transaction',
    conversionRate: 'Conversion Rate',
    changeDepositOrder: 'Change Deposit Order',
    changePayoutOrder: 'Change Payout Order',
    changeSettlementOrder: 'Change Settlement Order',
    manualIncreaseBalance: 'Manual Increase Balance',
    manualDecreaseBalance: 'Manual Decrease Balance',
    hint1: 'There is no data for the current time period',
    transactionAmountuests: 'Transaction Amountuests',
    rank: 'Rank',
    productProportion: 'Product Proportion',
    productAccountProportion: 'Product Account Proportion',
    totalBalance: 'Total Balance',
    merchantBalance: 'Merchant Balance',
    collection: 'Total Ant Balance',
    product_code: 'Product Name',
    succeed_amount: 'Transaction Amount',
    succeed_volume: 'Succeed Volume',
    succeed_rate: 'Rate',
    account_name: 'Account Name',
    account_type: 'Account Type',
    depositStatistics: 'Product stat',
    depositAccountStatistics: 'Account stat',
    totalTransact: 'Total Transactions',
    depositStat: 'Deposit stat',
    tooltip: 'Click to display more data',
    downloadType: 'Please select the type of export',
    depositExport: 'Deposit Export',
    withdrawExport: 'Withdraw Export',
    available_balance: 'Available Balance',
    total_available_balance: 'Total Available',
    subProductList: 'Sub Product Statistics',
    product_name: 'Product Name',
    sub_product_name: 'Sub Product Name',
    contains_sub_products: ' (Contains Sub Products)'
  },
  manager: {
    userName: 'Username',
    select: 'select',
    reset: 'reset',
    export: 'export',
    currentDevice: 'Current Device',
    OtherDevice: 'Other Device',
    managerType: 'Manager Type',
    ipWhiteList: 'IP WhiteList',
    editIP: 'Edit IP WhiteList',
    resetIp: 'Reset IP WhiteList',
    placeholder: 'Please Enter IP',
    availableCurrency: 'Available Currency',
    status: 'Status',
    active: 'Active',
    disable: 'Disable',
    operation: 'Operation',
    passWord: 'Password',
    email: 'Email',
    admin: 'admin',
    manager: 'manager',
    send_email: 'Send email',
    login_password_changed: 'Force merchants to change their login password',
    withdraw_password_changed: 'Force merchants to change withdrawal passwords',
    yes: 'YES',
    no: 'No',
    merchant_domain: 'Merchant Domain',
    ant_product_account_group: 'Ant Payment Group',
    checkout_counter_domain: 'Checkout Counter Domain',
    currency_timezone_map: 'Currency Timezone',
    taskDescription: 'Task Description',
    googleCode: 'Google Code',
    close: 'Close',
    save: 'Save',
    createdBy: 'Created by',
    startPlaceholder: 'Created Start Time',
    endPlaceholder: 'Created End Time',
    createdTime: 'Created time',
    description: 'Description',
    add: 'Add',
    merchantNo: 'Merchant No',
    merchantName: 'Merchant Name',
    name: 'Name',
    balance: 'Balance',
    edit: 'Edit',
    del: 'Delete',
    createMerchant: 'Create Merchant',
    delMerchant: 'Delete Merchant',
    basicInformation: 'Basic Information',
    password: 'Password',
    phone: 'Phone',
    pinForWithdraw: 'Pin for Withdraw',
    remarks: 'Remarks',
    introduceAgent: 'Introduce Agent',
    modify: 'Modify',
    safetyInformation: 'Safety Information',
    merchantKey: 'Merchant Key',
    depositNotifyURL: 'Deposit Notify URL',
    content1:
      '1. The URL must start with http or https, and query string is not allowed.',
    content2: '2. The URL supports the template variable: ',
    content3: '- merchant_ref (merchant order number), the format is',
    content4: '- product, the format is',
    content5: 'For example:',
    content6: 'Suppose the merchant order number is 123456, product is ThaiQR',
    content7: 'The URL address is https://your_domain.com/path1/',
    content8: 'The final requested address is',
    returnURL: 'Return URL',
    withdrawNotifyURL: 'Withdraw Notify URL',
    IPWhiteList: 'IP WhiteList',
    gogleAuth: 'Google Auth',
    pass_notify_url: 'Allow Pass Notify URL',
    allow_merchant_set_IP_whitelist: 'Merchant Configuration IP Whitelist',
    cancel: 'Cancel',
    createNext: 'Create/Next',
    editMerchant: 'Edit merchant',
    batchEditProduct: 'Batch modify merchant product configurations',
    productManage: 'Product Manage',
    agentProductManage: 'Agent Product Manage',
    accountsBalance: 'Accounts Balance',
    settlementAccounts: 'Settlement Accounts',
    depositOrder: 'Deposit Order',
    payoutOrder: 'Payout Order',
    settlementOrder: 'Settlement Order',
    manager1: 'Manager',
    productList: 'Product List',
    productType: 'Product Type',
    productName: 'Product Name',
    accountSelect: 'Account inquiry',
    settlementLimit: 'Settlement Limit',
    settlement: 'Single Amount',
    small_fee: 'Small transaction fee',
    settlementTime: 'Settlement Time',
    depositTime: 'Deposit time',
    fee: 'Fee',
    limits: 'Single Limits',
    limit: 'Limit',
    availableTime: 'Available Time',
    merchantProduct: 'Merchant Product',
    productAccount: 'Product Account',
    currency: 'Currency',
    tiShi:
      'There is no account group for this product, please choose other products',
    tiShi2: 'Please select the product first',
    tiShi3: 'Please select a time range',
    tiShi4: 'Please create a product account first',
    tiShi5:
      'There is no account group for this product, please select another product account',
    productAccountGroup: 'Product Account Group',
    create: 'Create',
    agentProduct: 'Agent Product',
    agentPrice: 'Agent Price',
    introducedMerchantsList: 'Introduced Merchants List',
    startTime: 'Start time',
    endTime: 'End time',
    depositAmount: 'Deposit Amount',
    depositCommission: 'Deposit Commission',
    payoutAmount: 'Payout Amount',
    payoutCommission: 'Payout Commission',
    settlementAmount: 'Settlement Amount',
    settlementCommission: 'Settlement Commission',
    resigersTime: 'Resigers time',
    rate: 'Rate',
    settledRebate: 'Settled Rebate',
    unsettledRebate: 'Unsettled Rebate',
    amount: 'Amount',
    exchangeRate: 'Exchange Rate',
    currentBalance: 'Current Balance',
    availableBalance: 'Available Balance',
    outstandingDeposit: 'Outstanding Deposit',
    pendingSettlement: 'Pending Settlement',
    pendingPayouts: 'Pending Payouts',
    adjustBalance: 'Adjust the balance',
    direction: 'Direction',
    decrease: 'Decrease',
    increase: 'Increase',
    accountsStatement: 'Accounts Statement',
    cause: 'Cause',
    orderNumber: 'Order Number',
    minAmount: 'Min Amount',
    maxAmount: 'Max Amount',
    beforeBalance: 'Before Balance',
    afterBalance: 'After Balance',
    test_order: 'Compensating Balance',
    pay_time_duration: 'Pay Time Duration （min）',
    sourceIP: 'Source IP',
    reserve_balance: 'Reserve Balance',
    reserve_balance_config: 'Reserve Balance Config',
    reserve_rate: 'Rate',
    systemRef: 'System Ref',
    createExchangeRate: 'Create Exchange Rate',
    editExchangeRate: 'Edit Exchange Rate',
    basicCurrency: 'Basic Currency',
    quoteCurrency: 'Quote Currency',
    mode: 'Mode',
    bid: 'Bid',
    ask: 'Ask',
    bankAccounts: 'Bank Accounts',
    information: 'Information',
    bankAccount: 'Bank Account',
    bankCode: 'Bank Code',
    accountName: 'Account Name',
    accountNo: 'Account No',
    volume: 'Volume',
    created: 'Created',
    unpaid: 'Unpaid',
    success: 'Success',
    successful: 'Successful',
    depositOrderList: 'Deposit Order List',
    callbackType: 'Callback Type',
    notifyStatus: 'Notify Status',
    notifyStartTime: 'Notify Start Time',
    notifyEndTime: ' Notify End Time',
    instruction: 'Instruction',
    merchantRef: 'Merchant Ref',
    productRef: 'Product Ref',
    requestAmount: 'Request Amount',
    paidAmount: 'Paid Amount',
    productStatus: 'Product Status',
    notifiedTime: 'Notified Time',
    pendingAmount: 'Pending Amount',
    pendingTransaction: 'Pending Transaction',
    successAmount: 'Success Amount',
    successTransaction: 'Success Transaction',
    freezeAmount: 'Freeze Amount',
    freezeTransaction: 'Freeze Transaction',
    rejectAmount: 'Reject Amount',
    rejectTransaction: 'Reject Transaction',
    payoutOrderList: 'Payout Order List',
    source: 'Source',
    bankName: 'Bank Name',
    approvedTime: 'Approved Time',
    settlementOrderList: 'Settlement Order List',
    userManagement: 'User Management',
    username: 'Username',
    noData: 'There is no data',
    attach: 'Attach',
    attachEdit: 'Edit Attach ',
    loginLog: 'Login Log',
    operation_type: 'Operation Type',
    change_balance: 'Change Balance',
    freeze_balance: 'Freeze Balance',
    accountPhone: 'Account Phone',
    agency: 'Subordinate Agent',
    refund_min_fee: 'Refund Fee',
    pending_refund_balance: 'Pending Refund',
    today_pending_settlement_balance: 'Can be settled today',
    balance_type: 'Balance Type',
    feeSetting: 'Handling fee setting',
    paymentMethod: 'Payment method',
    amountLimit: 'Amount limit',
    team: 'Gcash Manager',
    cardManager: 'Card Manager',
    device_id: 'Device ID',
    os: 'System Type',
    os_version: 'System Version',
    browser: 'Browser Name',
    family: 'Device Type',
    brand: 'Device Brand',
    location: 'Address',
    new: 'New Equipment',
    apply_from: 'Login Mode',
    apply_by: 'Operation Administrator',
    belive: 'Trust Device',
    device_info: 'Device Info',
    Email: 'Email Verification Code',
    seconds: 'seconds to retrieve',
    get_code: 'Get Code',
    card_3d: 'Card 3D',
    hongKongHost: 'Using Hong Kong Host',
    is_bank: 'Bank verification',
    card_config: 'Card Config',
    period: 'Period(Hour)',
    count: 'Count'
  },
  taskCenter: {
    approved_by_name: 'Approved by name',
    select: 'select',
    reset: 'reset',
    export: 'export',
    productName: 'Product Name',
    createdBy: 'Created By',
    approvedBy: 'Approved By',
    status: 'Status',
    startPlaceholder: 'Created Start Time',
    endPlaceholder: 'Created End Time',
    handleStartTime: 'Handle Start Time',
    handleEndTime: 'Handle End Time',
    timeType: 'Time Type',
    title: 'Title',
    description: 'Description',
    content: 'Content',
    expectStatus: 'Expect Status',
    approval: 'Approval',
    callback_amount: 'Expected Amount',
    approvalMany: 'ApprovalMany',
    Reject: 'Reject',
    createdTime: 'Created Time',
    lasteTime: 'Laste Time',
    updateTime: 'Update time',
    successTime: 'Success Time',
    approveTime: 'Approved Time',
    handleTime: 'Handle Time',
    operation: 'Operation',
    review: 'Review',
    googleQRCode: 'Google QR Code',
    download: 'download',
    googleCode: 'Google Code',
    cancel: 'Cancel',
    confirm: 'OK',
    fee: 'Fee：',
    fee1: 'Fee',
    pendingAmount: 'Pending Amount：',
    pendingTransaction: 'Pending Transaction：',
    successAmount: 'Success Amount：',
    successTransaction: 'Success Transaction：',
    freezeAmount: 'Freeze Amount：',
    freezeTransaction: 'Freeze Transaction：',
    rejectAmount: 'Reject Amount：',
    rejectTransaction: 'Reject Transaction：',
    order_number: 'Order Number',
    child_ordernumber: 'Withdraw Ref',
    merchant_no: 'Merchant No',
    min_amount: 'Min Amount',
    max_amount: 'Max Amount',
    min_coin: 'Min Coin',
    max_coin: 'Max Coin',
    source: 'Source',
    product_account_group: 'Product Group',
    upstream_status: 'Product Status',
    startPlaceholder1: 'Created Start Time',
    endPlaceholder1: 'Created End Time',
    startPlaceholder2: 'Success Start Time',
    endPlaceholder2: 'Success End Time',
    batchPaid: 'Batch Paid',
    openPayfor: 'One-Click Paid',
    batchModifyStaus: 'Batch Change',
    merchantRef: 'Merchant Ref',
    systemRef: 'System Ref',
    depositId: 'ID',
    productRef: 'Product Ref',
    amount: 'Amount',
    information: 'Information',
    states: 'States',
    notifyStatus: 'Notify Status',
    notifiedTime: 'Notified Time',
    Approval: 'Approval',
    ChangeOrder: 'Change Order Status',
    Change: 'Change',
    Query: 'Query',
    Details: 'Details',
    OrderDetails: 'Order Details',
    billDetails: 'Bill Details',
    accountName: 'Account Name',
    accountNo: 'Account No',
    bankCode: 'Bank Code',
    address: 'Address',
    coinType: 'Coin Type',
    product: 'Product',
    productAccount: 'Product Account',
    selectProduct: 'Please select the product first',
    success: 'Success',
    pending: 'Pending',
    rejected: 'Rejected By Platform',
    remarks: 'Remarks',
    taskDescription: 'Task Description',
    orderInformation: 'Order Information',
    merchantsDetail: 'Merchants Detail',
    accountsStatnment: 'Accounts Statement',
    interfaceInformation: 'Interface Information',
    notify: 'Notify',
    currency: 'Currency',
    productStatus: 'Product Status',
    productInformation: 'Product Information',
    productAccountName: 'Product Account Name',
    productAccountNo: 'Product Account No',
    productAccountType: 'Product Account Type',
    Upstream: 'Upstream',
    Downstream: 'Downstream',
    notifyURL: 'Notify URL',
    returnURL: 'Return URL',
    requestTime: 'Request Time',
    notifyTime: 'Notify Time',
    notifyBody: 'Notify Body',
    request: 'Request',
    response: 'Response',
    Key: 'Key',
    Value: 'Value',
    notifyRequest: 'Notify Request',
    notifyResponse: 'Notify Response',
    orderNumbers: 'Order Numbers',
    withdrawRef: 'Withdraw Ref',
    fundInformation: 'Fund Information',
    rquestAmount: 'Request Amount',
    paidAmount: 'Paid Amount',
    Attach: 'Attach',
    direction: 'Direction',
    exceptionType: 'Exception Type',
    batchReview: 'Batch Review',
    startId: 'Start ID',
    endId: 'End ID',
    startHolder: 'Please input Start ID',
    endHolder: 'Please input End ID',
    type: 'Type',
    reason: 'Reason',
    associatedOrderNumber: 'Associated Order Number',
    batchModifyOrderStatus: 'Batch Modify Order Status',
    batchModifyFreezeOrder: 'Batch Unfreeze',
    batchOrderNotify: 'Batch Notify',
    openKickOut: 'Kick Out',
    message: 'Message',
    queryOrder: 'Query Order Info',
    orderInfoHolder: 'input merchant ref for order details',
    orderInfoHolder1: 'Default processing based on order amount',
    noData: 'No data at present',
    event: 'Event',
    selectMethod: 'Select Processing Mode',
    merchantOrder: 'Callback Order',
    accountBalance: 'Add Balance',
    merchantNo: 'Merchant No',
    accountStatement: 'Account Statement',
    action: 'Processing Mode',
    freeze_duration: 'Freeze Duration（minute）',
    instruction: 'Instruction',
    reverse_order: 'Reverse Order',
    reversal: 'Reversal',
    gateway_url: 'Gateway URL',
    field: 'Wallet Address',
    range: 'Amount Range',
    rangeDate: 'Date Range',
    queryParams: 'Query Params',
    multiple_order_number: 'Multi Order Number',
    multipleOrderTips1: 'Current',
    multipleOrderTips2: 'Order Numbers',
    multipleOrderTips3:
      '，To add a new order, use a comma after the last order',
    multipleOrderTips4:
      'Please line up multiple order numbers in Excel or TXT and copy and paste them into the input box',
    OneClickChange: 'One-Click Change',
    OneClickUnfreeze: 'One-Click Unfreeze',
    multi_child_ordernumber: 'Multi Withdraw Ref',
    rate: 'Conversion Rate',
    total_volume: 'Topup Amount',
    total_count: 'Topup Order',
    uncollect_amount: 'Uncollected Amount',
    success_volume: 'Successful Amount',
    success_count: 'Successful Order',
    childOrder: 'Child Order',
    withdrawal: 'Withdrawal Setting',
    walletId: 'Multiple Wallet ID',
    refund_order: 'Deposit Order Number',
    cap_status: 'CAP Status',
    mode: 'Bot Cars Batch Review',
    time: 'Bot Cars Time Settings'
  },
  product: {
    category: 'Merchant Category Code',
    name: 'Name',
    currency: 'Currency',
    productType: 'Product Type',
    product: 'Product',
    status: 'Status',
    accounts: 'Accounts',
    operation: 'Operation',
    edit: 'Edit',
    del: 'delete',
    cashierDeskConfiguration: 'Cashier Desk Configuration',
    noData: 'There are currently no configurable items',
    bankDeskConfiguration: 'Bank Desk Configuration',
    subProduct: 'Sub Product Fee',
    close: 'Close',
    modify: 'Modify',
    accountType: 'Account Type',
    cashierConfig: 'Add Cashier Config',
    cashierEditConfig: 'Edit Cashier Config',
    coin_balance: 'Coin Balance',
    bankCode: 'Bank Code',
    bnakName: 'Bnak Name',
    logo: 'Logo',
    editProductBank: 'Edit Product Bank',
    priority: 'Priority',
    add: 'Add',
    onlineState: 'Online State',
    accountNo: 'Account No',
    accountName: 'Account Name',
    accountGroup: 'Account Group',
    active: 'Active',
    inactive: 'Inactive',
    block: 'Block',
    wait: 'Wait Review',
    reject: 'Reject',
    approve: 'Review Approve',
    rejectApprove: 'Review Reject',
    disable: 'Disable',
    select: 'select',
    reset: 'reset',
    limits: 'Limits',
    dailyLimitedVolume: 'Daily Limited Volume',
    availableVolume: 'Available Volume',
    dailyLimitedTransaction: 'Daily Limited Transaction',
    availableTransaction: 'Available Transaction',
    today_deposit_amount: 'Today Deposit Amount',
    margin_balance: 'Margin Balance',
    hook_start_time: 'Order opening time',
    daily_rate: 'Successful Rate',
    matching: 'Matching Order',
    hookBalance: 'Hook Balance',
    dedicatedMerchant: 'Dedicated Merchant',
    createProductAccount: 'Create product account',
    basicInformation: 'Basic Information',
    transaction: 'Transaction',
    statistical: 'Account Statistics',
    productName: 'Product Name',
    pollingWeight: 'Polling weight',
    collectAddress1: 'Collection Address',
    collectAddress2: 'Pay Wallet',
    SystemAmount: 'System Transaction Amount',
    manual_amount: 'Manual Amount',
    collect_amount: 'Collection Amount',
    consume: 'Consumption TRX',
    abnormal_txn: 'Abnormal Transaction',
    abnormal_txn_count: 'Number of Abnormal Transactions',
    productAccountGroup: 'Product Account Group',
    remarks: 'Remarks',
    back: 'Back',
    createNext: 'Create/Next',
    configuration: 'Configuration',
    click: 'Click',
    info: 'View help instructions',
    create: 'Create',
    clear: 'Clear',
    saveNext: ' Save/Next',
    pleaseSelect: 'Please select',
    createWallet: 'Create Wallet',
    limitation: 'Limitation',
    availableTime: 'Available Time',
    selectTimeRange: 'Please select a time range',
    queryFrequency: 'Polling Frequency',
    frequencyTips: 'Turn on polling, the default frequency is 1 minute',
    limit: 'Limit',
    save: 'Save',
    editAccount: 'Edit account',
    statistics: 'Statistics',
    todayVolume: 'Today Volume',
    todayAvailableVolume: 'Today Available Volume',
    todaySuccessTransaction: 'Today Success Transaction',
    todaySuccessfulRate: 'Today Successful Rate',
    totalVolume: 'Total Volume',
    totalTransaction: 'Total Transaction',
    orderDetails: 'Order Details',
    systemRef: 'System Ref',
    merchantRef: 'Merchant Ref',
    notifyStatus: 'Notify Status',
    createdStartTime: 'Created Start Time',
    createdEndTime: 'Created End Time',
    merchantNo: 'Merchant No',
    prePayAmount: 'PrePay Amount',
    paidAmount: 'Paid Amount',
    createdTime: 'Created Time',
    notifiedStatus: 'Notified Status',
    walletAddress: 'Wallet Address',
    payment_wallet: 'Payment Wallet',
    privateKey: 'Private Key',
    productAccount: 'Product Account',
    weight: 'Polling Weight',
    quanzhong: 'Please select product account',
    tiShi: 'There is no account for this product, please choose other products',
    hoder: 'Please enter the account group name',
    collectionlog: 'Wallet Address collection-log',
    fromAddress: 'From Address',
    toAddress: 'To Address',
    transactionID: 'Transaction ID',
    productRef: 'Product Ref',
    message: 'Message',
    account_name: 'Account Name',
    account_no: 'Account No',
    user_id: 'Device Name',
    from_val: 'From',
    createtime: 'Create time',
    creatingAccountGroup: 'Creating an Account Group',
    editAccountGroup: 'Edit an Account Group',
    amount: 'Amount',
    uncollectedAmount: 'Not Collected Amount',
    coinAmount: 'Not Collected Coin Amount',
    address: 'Address',
    balance: 'Balance',
    collectionLog: 'Collection Log',
    extraParam: 'Product Configuration',
    productPluginConfig: 'Product Plugin Configuration',
    extraParam1: 'Withdraw Queue',
    extraParam2: 'UPI Timeout Setting',
    extraParam3: 'Share Payout Account',
    share_payout_account: 'Open Share Payout Account',
    skipQueue: 'No Queuing',
    setTimeout: 'Setting Up Callback Timeout',
    open: 'Open',
    setTime: 'Timeout Setting(Second)',
    timeoutTisp: 'The default is 30 minutes, or 1800 seconds',
    frequency: 'Frequency(Second)',
    bill: 'Withdrawal frequency',
    frequency1: 'Frequency(Minute)',
    api_key: 'API Key',
    cannot: 'Open State,The Frequency Cannot Be 0',
    not_display_qrcode: 'Not Display Qrcode',
    floating_amount: 'Floating Amount',
    not_display_qrcode1: 'Merchant Not Display Qrcode',
    not_display_qrcode2: 'Application Not Display Qrcode',
    jump_checkout_counter_mode: 'Jump Checkout Counter Mode',
    checkout_counter_mode: 'Checkout Counter Mode',
    server: 'server',
    rate: 'Rate',
    volume: 'Volume',
    success_volume: 'Success Volume',
    emptyMerchant: 'Emptying dedicated Merchant',
    addApikey: 'Add API Key',
    stakeWallet: 'Auto Staking',
    stakeRecord: 'Manual Staking',
    receiver_name: 'Receiver Account',
    resource: 'Resource',
    energy: 'Energy',
    bandwidth: 'Bandwidth',
    fee_saving: 'Fee Saving',
    frozen_balance: 'Frozen Balance(Trx)',
    freeze: 'Freeze',
    unfreeze: 'UnFreeze',
    unfreezing: 'Unfreeze Progress',
    isunfreeze: 'Unfreezing',
    unfreeze_percent: 'Unfreeze Percent',
    cause: 'Cause',
    buy_unfreeze: 'Buy Unfreeze',
    buy_unfreeze1: 'Buy Freeze',
    topup_unfreeze: 'Topup Unfreeze',
    topup_unfreeze1: 'Topup Freeze',
    freeze_percent: 'Freeze Percent',
    totalAmountFreezeend: 'Total Frozen Amount',
    expectedThawing: 'Expected Unfreeze Amount',
    expectedFreeze: 'Expected Freeze Amount',
    failed: 'Failed',
    unfreezeend: 'Unfreeze',
    freeze_txn_id: 'Freeze Transaction ID',
    unfreeze_txn_id: 'Unfreeze Transaction ID',
    product_code: 'Product',
    product_account_name: ' Product Account Name',
    createPledge: 'Stake Trx',
    unfreezePledge: 'Unfreeze',
    unfreeze_time: 'Unfreeze Time',
    get: 'Get',
    product_detail: 'Product Detail',
    work_dir: 'Work Dir',
    Log: 'Log',
    program: 'Program',
    pid: 'PID',
    start_plug: 'Start',
    reload_plug: 'Reload',
    stop_plug: 'Stop',
    unlock_plug: 'Query',
    add_btn: 'Add',
    apply_view_log: 'View Log',
    change_pin: 'Change Pin',
    prompt: 'Prompt',
    otp: 'OTP code',
    otpTips: 'OTP Sign',
    automatic_payment: 'Automatic Payment',
    can_withdraw_balance: 'Can Withdraw Balance',
    frozen: 'Withdrawal Frozen Amount',
    extract: 'Extract',
    pledge: 'Pledge',
    agency: 'Agency',
    accout: 'Proxy Account',
    Address: 'Proxy Address',
    type: 'Agent Type',
    number: 'Agency Balance(Trx)',
    principal: 'Redeemable Pledged Principal',
    sleep: 'Sleep',
    notify_after_collect: 'Notify After Collect',
    last_collect_time: 'Last Collect Time',
    change_tiem: 'Edit Tiem',
    amount_timeout: 'Lock Float Amount Time （min）',
    review: 'Ant Account',
    coin_type: 'Coin Type',
    active_time: 'Valid duration of code(min)',
    sms_message: 'SMS template',
    note: 'Note: SMS Template Verification code placeholder {{code}}',
    sms_edit: 'SMS Configuration',
    expiration_time: 'Setting expiration time',
    cashier: 'Setting expiration time of the cashier',
    queueType: 'Queue type',
    unify: 'Unified queuing time',
    separate: 'Separate queue time',
    separateQueues: 'Set separate queues',
    utrWeight: 'UTR Polling Sort',
    utrWeight1: 'Please select accounts in order for sort',
    product_sub_switch: "Enable or not",
    product_sub_code: 'Sub Product',
    product_sub_info: 'Sub Product Fee Info',
    product_sub_fee: 'Child Product Fee',
    sub_rate: 'Rate',
    min_fee: 'Min Fee',
    fixed_fee: 'Fixed Fee',
    max_amount: 'Max Amount',
    min_amount: 'Min Amount',
    addSubConfig: 'Add Rate Config',
    delete: 'Delete',
    amount_range_error: 'The maximum amount must be greater than or equal to the minimum amount',
    amount_continuity_error: 'The minimum amount must be greater than the maximum amount of the previous item',
    fee: 'Fee',
    gateway_transaction_fee: 'Gateway fee',
  },
  test: {
    product: 'Product',
    productAccount: 'Product Account',
    selectProduct: 'Please select the product first',
    amount: 'Amount',
    extra: 'Extra',
    merchant: 'Merchant',
    tips: 'Please enter merchant no',
    tips1: 'Please select the payment method',
    tips2: 'Please select the transit choice',
    is_api_integrate: 'Integrated API: 1, Cashier: 0',
    subTips1: 'API direct connection：',
    subTips2: 'You must select a sub product and fill in the corresponding additional parameters.',
    subTips3: 'Cashier mode：',
    subTips4: 'Please do not select sub products.',
  },
  download: {
    relatedSoftware: 'Related software'
  },
  report: {
    merchantNo: 'Merchant No',
    startTime: 'Start Time',
    endTime: 'End Time',
    select: 'select',
    reset: 'reset',
    export: 'export',
    date: 'Date',
    merchantName: 'Merchant Name',
    openingBalance: 'Opening Balance',
    endingBalance: 'Ending Balance',
    startingPendingBalance: 'Starting Pending Balance',
    endingPendingBalance: 'Ending Pending Balance',
    type: 'Type',
    amount: 'Amount',
    volume: 'Volume',
    fee: 'Fee',
    manualInterventionVolume: 'Manual Intervention Volume',
    manualInterventionAmount: 'Manual Intervention Amount',
    manualInterventionTransaction: 'Manual Intervention Transaction',
    begin: 'Begin',
    end: 'End',
    productName: 'Product Name',
    currency: 'Currency',
    product: 'Product',
    transactionVolume: 'Transaction Volume',
    rebate: 'Rebate',
    count: 'Number of people',
    level: 'Level',

    new_ant_account: 'New account',
    first_topup_when_register: 'First topup account when register',
    first_topup_ant_account_when_register: 'First topup amount when register',
    active_ant_account: 'Active account',
    topup_ant_account: 'Daily topup account',
    topup: 'Daily topup amount',
    first_topup_ant_account: 'First topup account',
    first_topup: 'First topup amount',
    withdraw: 'Withdrawal amount',
    sale_usdt: 'Sales amount',
    invitation_rebate: 'Invitation rebate',
    sale_profit: 'Sale profit',
    succeed_deposit_amount: 'Deposit amount',
    deposit_fee: 'Deposit fee',
    succeed_deposit_volume: 'Succeed deposit volume',
    succeed_payout_amount: 'Merchant withdrawal',
    payout_fee: 'Deposit fee',
    succeed_payout_volume: 'Succeed payout volume',
    balance: 'Total balance',
    active_agent: 'Active agent',
    new_descendant: 'New descendant',
    descendant_first_topup_count: 'New descendant first topup account ',
    descendant_first_topup_amount: 'New descendant account amount',
    create_time: 'Create time',
    exchange: 'Exchange Data',
    upper: 'Upper Data',
    risk: 'Risk Control',
    nickname: `Sender's nickname`,
    coin_id: 'Coin ID',
    upper_limit: 'Upper Limit',
    unit_quantity: 'Number U',
    rupee_quantity: 'Rupee Quantity',
    exchange_rate: 'Exchange rate',
    pay_type: 'Payment method',
    name: 'Seller Name',
    order_time: 'Order Time'
  },
  setting: {
    manageBackEndDomain: 'Manage Back-End Domain',
    merchantBackEndDomain: 'Merchant Back-End Domain',
    checkoutCounterDomain: 'Checkout Counter Domain',
    modify: 'Modify',
    siteName: 'Site Name',
    siteLogo: 'Site Logo',
    testMerchantNo: 'Test Merchant No',
    googleAuthentication: 'Google Authentication',
    botGoogleAuthentication: 'Bot Google Authentication',
    addExchangeRate: 'Add Exchange Rate',
    baseCurrency: 'Base Currency',
    quoteCurrency: 'Quote Currency',
    mode: 'Mode',
    bid: 'Bid',
    ask: 'Ask',
    operation: 'Operation',
    edit: 'Edit',
    delete: 'Delete',
    back: 'Back',
    cancel: 'Cancel',
    save: 'Save',
    create: 'Create',
    editMerchantNo: 'Edit Merchant No',
    taskDescription: 'Task Description',
    editCheckoutCounterDomain: 'Edit Checkout Counter Domain',
    editExchangeRate: 'Edit Exchange Rate',
    notify_switch: 'Payout Notify Switch',
    auto_refund: 'Auto Refund Switch',
    ant_payout_payment_switch: 'Ant compete for orders',
    notify_withdraw_switch: 'Payout Payment Review Task Notice',
    notify_usdt_collect_switch: 'USDT Notify Switch',
    thai_notify_switch: 'Thai Notify Switch',
    inr_notify_switch: 'INR Notify Switch',
    php_notify_switch: 'PHP Notify Switch',
    eur_notify_switch: 'EUR Notify Switch',
    ngn_notify_switch: 'NGN Notify Switch',
    rm_notify_switch: 'RM Notify Switch',
    safety_notify_switch: 'Safety Notify Switch',
    gcash_notify_switch: 'GCash Notify Switch',
    gcashTgTitle: 'Telegram GCash Notify',
    usd_cap_notify_switch: 'CAP Exception Switch',
    usd_cap_notify_telegram_group: 'Telegram CAP exception Notify',
    ant_limit_notify_switch: 'Ant Limit Notify Switch',
    ant_register_notify_switch: 'Ant Register Notify Switch',
    ant_limit_notify_telegram_group: 'Telegram Ant Limit Notify Switch',
    addGroup: 'Add telegraph notify group',
    payTgTitle: 'Telegram Payout Notify',
    usdtTgTitle: 'Telegram USDT Notify',
    thaiTgTitle: 'Telegram Thai Notify',
    inrTgTitle: 'Telegram INR Notify',
    phpTgTitle: 'Telegram PHP Notify',
    eurTgTitle: 'Telegram EUR Notify',
    ngnTgTitle: 'Telegram NGN Notify',
    groupId: 'Telegram Group ID',
    inputGroupId: 'Please Enter Group ID',
    inputGroupId1: 'Please enter the group ID and account type (separated by semicolons)',
    inputQueryId: 'Please enter group name to query group ID',
    queryBtn: 'Query',
    telegram_robot_token: 'Telegram Service Token',
    telegram_devops_robot_token: 'Telegram Bot Token',
    setTimeZone: 'Currency Timezone',
    tab1: 'System Settings',
    tab2: 'Telegram Robot',
    tab3: 'Service Robot',
    tab4: 'Basic Settings',
    tab5: 'Rebate Settings',
    tab6: 'Suggest Rebate',
    tab7: 'Account Forward',
    tab8: 'FP Robot',
    ant_withdraw_max_order_count: 'Ant Withdraw Max Order Count',
    ant_withdraw_expire_min: 'Ant Withdraw Expire(min)',
    buy_usdt_rate: 'Buy USDT Rate',
    rateBuyLog: 'Buy USDT Rate Setting',
    buy_freeze: 'Buy Freeze settings',
    sale_usdt_rate: 'Sale USDT  Rate',
    rateSakeLog: 'Sale USDT  Rate Setting',
    baseFreeze: 'Principal Freeze',
    baseFreezeLog:
      'Prevent users from freezing the amount (hours) without transaction payment',
    exchangeFreezeLog:
      'Prevent the user from freezing the amount without acceptance (hours)',
    sale_usdt_rebate_rate: 'Sale USDT Rebates',
    buy_usdt_rebate_rate: 'Buy USDT Rebates',
    sale_rebate_freeze_tie: 'Sale USDT Commission Freeze Time',
    buy_rebate_freeze_time: 'Buy USDT Commission Freeze Time',
    exchange_usdt_rebate_rate: 'Exchange USDT Rebates',
    exchange_rebate_freeze_time: 'Exchange USDT Commission Freeze Time',
    rebateRateLog:
      'The proportion of commission refunds to superiors after successful order transactions is 0-100, for example: 5=5% of the counter order amount',
    rebateRateAnt:
      'The proportion of commission refunds to ants after successful order transactions is 0-100, for example: 5=5% of the counter order amount',
    freezeTime: 'Commission Freeze Time',
    in_maintain: 'Unavailable bank',
    freezeTimeLog:
      'To prevent users from refunding and withdrawing commissions, it is necessary to set a commission freeze time (days)',
    yiji: 'Level 1 Commission Rebate Ratio',
    erji: 'Level 2 Commission Rebate Ratio',
    sanji: 'Level 3 Commission Rebate Ratio',
    safety: 'Safety Notification Switch',
    safetyTg: 'Telegram Security Notice',
    kefu_link: 'Customer Service Link',
    topup_freeeze: 'Topup Freeeze',
    wallet_reset_duration: 'Duration of recharge address usage (years)',
    register_switch: 'Register Switch',
    register_apply_switch: 'Register Apply Switch',
    notAllowed: 'Not Allowed',
    allow: 'Allow',
    notNeed: 'No Need Review',
    need: 'Need Review',
    close_buy: 'Payment function',
    ant_trc20: 'TRC20 Control Switch',
    ant_erc20: 'ERC20 Control Switch',
    ant_inr: 'INR Control Switch',
    wallet_delete_switch: 'Delete Account',
    test_order_notify_switch: 'Test Order Notification',
    telegram_account_switch: 'Message Forwarding',
    fee: 'Withdrawal Commission',
    trc_fee: 'TRC20 Withdrawal Commission',
    erc_fee: 'ERC20 Withdrawal Commission',
    clave_notify_switch: 'Clave Recognize',
    buy_platform_usdt_rate: 'Buy Platform USDT Rate',
    buy_platform_usdt_min_amount: 'Buy Platform USDT Min Amount',
    merchant_deposit_settlment_rate: 'Merchant Deposit Settlment Rate',
    merchant_payout_settlment_rate: 'Merchant Payout Settlment Rate',
    merchant_exchange_settlment_rate: 'Merchant Exchange Settlment Rate',
    ant_google_auth: 'Ant Withdraw Google Verification',
    open: 'Open Verification',
    close: 'Close Verification',
    send: 'Send Secret',
    reset: 'Reset Secret',
    photo: 'Picture Recognition',
    asyn_photo_switch: 'Asyn Picture Recognition',
    api_error_switch: 'Api Error Switch',
    api_sms_switch: 'Api SMS Switch',
    rm_deposit_notify_switch: 'RM Deposit Notify Switch',
    rm_payout_notify_switch: 'RM Payout Notify Switch',
    rm_collect_notify_switch: 'RM Collect Notify Switch',
    score: 'Upscore Recognition',
    cars_switch: 'Car Switch',
    bot_cars_switch: 'Blended Card Mode',
    bot_cars_setting: 'Bot Cars Setting',
    bot_cars_edit: 'Bot Cars Edit',
    app_setting: 'APP system notification',
    choose_ant: 'Ant account',
    content: 'Notice content',
    send_content: 'Send notification',
    record: 'Notification record',
    switch: 'Switch',
    off: 'Off',
    required: 'Required',
    optional: 'Optional',
    account_rate_notify_switch: 'Account Success Rate Drop Alert',
    bot_cert_style: 'Certificate Style',
    merchant_no_list: 'Merchant Group',
    merchantPlaceholder: 'Support multiple merchant accounts, separated by commas',
    errorMessage: 'The format is incorrect, perhaps due to the use of incorrect English commas. Please check',
    delicacy: 'Delicacy',
    simple: 'Simple',
    change_style: 'Change Certificate Style',
    holiday: "Holiday settlement delay",
    days: 'Days',
    holidayConfig: 'Add holiday deferred settlement configuration',
    holidayName: 'Holiday Name',
    fp_robot_token: 'FP Robot Token',
    fp_bot_switch: 'Check Switch',
    exchange_switch: 'Exchange Switch',
    fp_chat_id: 'Group ID',
    fp_exchange_markup: 'Exchange Rate',
    fp_merchant_id: 'Merchant ID',
    fp_merchant_app_id: 'APP ID',
    fp_merchant_api_key: 'API Key',
    payout_risk_duplicate_account_switch: 'Risk control switch',
    payout_risk_duplicate_account_window_hours: 'Repeated withdrawal (hours)',
    payout_risk_duplicate_account_max_count: 'Number of duplicate payment accounts',
    merchant_login_google_auth_switch: 'Merchant login Google verification',
    merchant_backoffice_payout_switch: 'Merchant Backend Payment/Settlement Switch'

  },
  order: {
    total: 'Total',
    today: 'Today',
    succeedRequestAmount: 'Succeed Request Amount',
    Withdrawal: 'Withdrawal Review',
    succeedVolume: 'Succeed Volume',
    succeedPaidAmount: 'Succeed Paid Amount',
    volume: 'Volume',
    fee: 'Fee',
    conversionRate: 'Conversion Rate',
    auth_code: 'Auth Code',
    last4: 'Card last 4 digits',
    orderNumber: 'Order Number',
    merchantNo: 'Merchant No',
    instruction: 'Instruction',
    paidAmount: 'Paid Amount',
    a: 'Balance',
    b: 'Coin Balance',
    requestAmount: 'Request Amount',
    minAmount: 'Min Amount',
    maxAmount: 'Max Amount',
    productName: 'Product Name',
    productAccount: 'Product Account',
    status: 'Status',
    notifyStatus: 'Notify Status',
    timeType: 'Time Type',
    createdTime: 'Created Time',
    notifyTime: 'Notify Time',
    successTime: 'Success Time',
    error_notify: 'Error Notification',
    upstream_data: 'Upstream Data',
    type: 'Interface Request',
    data: 'Data',
    view: 'View',
    allTime: 'Created/Success Time',
    unfreezeTime: 'Unfreeze Time',
    createdStartTime: 'Created Start Time',
    createdEndTime: 'Created End Time',
    notifyStartTime: 'Notify Start Time',
    notifyEndTime: 'Notify End Time',
    successStartTime: 'Success Start Time',
    successEndTime: 'Success End Time',
    unfreezeStartTime: 'Unfreeze Start Time',
    unfreezeEndTime: 'Unfreeze End Time',
    select: 'select',
    reset: 'reset',
    export: 'export',
    merchantRef: 'Merchant Ref',
    systemRef: 'System Ref',
    productRef: 'Product Ref',
    productStatus: 'Product Status',
    operation: 'Operation',
    change: 'Change',
    details: 'Details',
    more: 'More',
    orderDetails: 'Order Details',
    changeOrders: 'Change Orders',
    expectStatus: 'Expect Status',
    payTime: 'Pay Time',
    selectDate: 'Please select date',
    remarks: 'Remarks',
    taskDescription: 'Task Description',
    cancel: 'Cancel',
    save: 'Save',
    createdBy: 'Created By',

    orderInformation: 'Order Information',
    billInfo: 'Bill Information',

    notify: 'Notify',
    currency: 'Currency',
    collectStatus: 'Collect Status',
    productInformation: 'Product Information',
    product: 'Product',
    productAccountName: 'Product Account Name',
    productAccountNo: 'Product Account No',
    productAccountType: 'Product Account Type',
    interfaceInformation: 'Interface Information',
    upstream: 'Upstream',
    downstream: 'Downstream',
    notifyURL: 'Notify URL',
    returnURL: 'Return URL',
    requestTime: 'Request Time',
    notifyBody: 'Notify Body',
    requestBody: 'Request Body',
    key: 'Key',
    value: 'Value',
    responseBody: 'Response Body',
    notifyRequestBody: 'Notify Request Body',
    notifyResponseBody: 'Notify Response Body',
    collectionLog: 'Collection Log',
    receipt: 'Transaction Receipt',
    issueddate: 'ISSUED DATE',
    paiddate: 'PAID DATE',
    debitAccount: 'DEBIT ACCOUNT',
    creditAccount: 'CREDIT ACCOUNT',
    utfNo: 'UTR NO',
    payment: 'PAYMENT AMOUNT',
    payStatus: 'PAYMENT STATUS',
    REMARKS: 'REMARKS',
    transactionStatus: 'TRANSACTION STATUS',
    receiptName: 'NAME',
    createTime: 'Create Time',
    print: 'PRINT',
    close: 'CLOSE',
    message: 'Message',

    pendingAmount: 'Pending Amount',
    pendingTransaction: 'Pending Transaction',
    successAmount: 'Success Amount',
    successTransaction: 'Success Transaction',
    freezeAmount: 'Freeze Amount',
    freezeTransaction: 'Freeze Transaction',
    rejectAmount: 'Reject Amount',
    rejectTransaction: 'Reject Transaction',
    information: 'Information',
    approvedBy: 'Approved By',
    success: 'Success',
    pending: 'Pending',
    rejectedPlatform: 'Rejected By Platform',
    source: 'Source',
    amount: 'Amount',
    refundAmount: 'Refund Amount',
    approvedTime: 'Approved Time',
    notifiedTime: 'Notified Time',
    refundTime: 'Refund Time',
    bankCode: 'Bank Code',
    request: 'Request',
    response: 'Response',
    accountName: 'Account Name',
    accountNo: 'Account No',
    withdrawInfo: 'Withdraw Info',
    bankName: 'Bank Name',
    logDetails: 'Request Log Details',
    notifyRequest: 'Notify Request',
    notifyResponse: 'Notify Response',
    withdrawRef: 'Withdraw Ref',
    query: 'Query',
    enqueue: 'Queue',
    migrateBtn: 'Apply review',
    migrateTit: 'Apply review',
    notify_ordernumber: 'Downstream Order',
    upstream_ordernumber: 'Upstream Order',
    product_account_no: 'Account No',
    test_order: 'Test Order',
    kaaz_bank: 'Bank verification query',
    info: 'Topup Information',
    setCollect: 'Collect Config',
    collect_wallet: 'Collect Wallet',
    fee_wallet: 'Fee Wallet',
    fee_limit: 'Fee Limit',
    min_collect_amount: 'Min Collect Amount',
    collect_by_stake: 'Collect By Stake',
    google_code: 'Google Code',
    setting: 'Recharge Setting',
    USDTBlance: 'USDT Balance',
    money_type: 'Wallet Type',
    saleAmount: 'Sales Amount',
    commission: 'commission',
    address: 'Collection Address',
    gas: 'Gas Price',
    price: 'Float Gas Level',
    refund: 'Refund Amount',
    fiat_amount: 'Fiat Amount',
    set_usdt: 'Settlement Amount',
    settlement_merchant_rate: 'Settlement Merchant Rate',
    settlement_rate: 'Settlement Ant Rate',
    prepay: 'Successful Fiat Amount',
    settlement_amount: 'Buy Amount',
    payment_card_type: 'Payment Card Type',
    card_last6: 'Last 6 card numbe',
    not: 'Not Initiated',
    pend: 'Be Launching',
    initiate: 'Initiate CAP',
    cap: 'CAP operations can be performed only on orders whose order status is successful and whose CAP status is uninitiated or failed',
    ok: 'Confirm',
    total_transaction: 'Total Transaction',
    total_successful_rate: 'Total Successful Rate',
    no_notify: 'Not Notified',
    yes_notify: 'Notified',
    upstream_amount: 'Exchange Amount',
    ordernumber: 'Exchange Order Number',
    refundRemarks: 'Reason for refund',
    refundHolder: 'Please enter the refund amount',
    refundHolder1: 'Please provide a detailed explanation of the reason for the refund',
    attention: 'Refund Notice：',
    attention1: 'The refundable amount cannot exceed the order amount',
    attention2: 'The settled order will be deducted from the merchants balance',
    attention3: 'Refund application cannot be revoked after submission',
  },
  title: {
    share: 'Share Account'
  },
  antManage: {
    accountId: 'Account ID',
    EmailNickname: 'Email/Nickname',
    email: 'Email',
    type: 'Type',
    balance: 'Margin balance',
    state: 'Status',
    ancestor: 'Ancestor',
    password: 'Password',
    create: 'Create',
    modifyBalance: 'Balance',
    buy_freeze_balance: 'Buy freeze',
    quota: 'Quota',
    subaccount: 'Subaccount',
    details: 'Details',
    amount: 'Amount',
    remarks: 'Remarks',
    inOrOut: 'Decrease or Increase',
    attach: 'Picture attachment',
    operation: 'Type of operation',
    people: 'Personal data',
    statistics: 'Data statistics',
    nickname: 'Account ID / Nickname',
    invitation_code: 'Invitation code',
    transaction: 'Transaction details',
    collection: 'Friends list',
    salesAmount: 'Sales Amount',
    cause: 'Detail type',
    detailId: 'Detail ID',
    ordernumber: 'System number',
    before_balance: 'Before balance',
    after_balance: 'After balance',
    create_time: 'Create time',
    ip: 'IP',
    trader: 'Trader',
    master: 'Master',
    sub: 'Subaccount',
    payType: 'Method of payment',
    outStutus: 'Off-line',
    online: 'Online',
    control: 'Risk Control',
    full: 'Full',
    decrease: 'Decrease',
    increase: 'Increase',
    from_ant: 'Outgoing account',
    to_ant: 'Transfer into account',
    change_balance: 'Change balance',
    upstream_remarks: 'Order introduction',
    fee: 'Fee',
    paid_amount: 'Paid Amount',
    successful_rate: 'Successful Rate',
    successful_transaction: 'Successful Transaction',
    total_transaction: 'Total Transaction',
    volume: 'Volume',
    registered: 'Registered User',
    onlineUser: 'Online User',
    last_login_time: 'Last Login Time',
    last_login_ip: 'Recently Login IP',
    last_login: 'Last Login Time',
    profit: 'Profit',
    rebate: 'Friend Rebate',
    collect: 'Sales Amount',
    freeze: 'Freeze Balance',
    payment: 'Purchase',
    withdraw: 'Withdraw Cash',
    topup: 'Top Up',
    topup1: 'Top Up Amount',
    settlement_address: 'Settlement Address',
    topup_address: 'Topup Address',
    available: 'Available Balance',
    pending_deposit_balance: 'Deposit',
    pending_payout_balance: 'Pay In Transit',
    freeze_balance: 'Rebate Rn Transit',
    manager_freeze_balance: 'Manager Freeze Balance',
    ancest: 'Ancestor',
    descendant: 'Descendant',
    select: 'Please select the upper and lower levels',
    one: 'First level subordinate',
    two: 'Second level subordinate',
    three: 'Third level subordinate',
    level: 'Level',
    buy: 'Buy',
    sale: 'Sale',
    account: 'Account List',
    rate: 'Rebate Rate',
    sale_status: 'Sale Status',
    sale_on: 'Open Sale',
    manual_change_balance: 'Manual Change Balance',
    sale_collection: 'Sale',
    ant_id: 'Ant ID',
    start_sale: 'Start Sale',
    stop_sale: 'Stop Sale',
    account_ids: 'Product Account',
    topup_transaction: 'Topup U Transaction',
    buy_u_topup: 'Buy U Topup',
    buy_u_topup_transaction: 'Buy U Topup Transaction',
    topup_u_total: 'Topup U Total Amount',
    success_rate: 'Success Rate',
    sale_transaction: 'Sale Transaction',
    sale_order_count: 'Sale Order Count',
    unlock: 'Unlock',
    lock: 'Lock',
    freezeBalance: 'Freeze Balance',
    Balance: 'Margin Balance',
    backstage: 'Ant Backstage',
    friend_setting: 'Friend Settings',
    close_self_rebate: 'Close Self Rebate',
    close_friend_rebate: 'Close Friend Rebate',
    open_self_rebate: 'Open Self Rebate',
    open_friend_rebate: 'Open Friend Rebate',
    recommender: 'Superior friend',
    deposit_balance: 'Pending Deposit Balance',
    negative_balance: 'Negative Balance',
    manager_freeze: 'Recharge Freeze',
    recently: 'Recently',
    last: 'Last',
    previous: 'Previous',
    is_low_rating: 'Low Rating',
    manage_freeze_balance: 'Recharge Frozen Amount'
  },
  gcash: {
    search: 'Search Content',
    onlie_status: 'Online Status',
    account_status: 'Account Status',
    account_id: 'Account Code',
    phone_number: 'Phone Number',
    sms_id: 'SMS Forwarder ID',
    kyc_grade: 'KYC Grade',
    remain_money: 'Balance(PHP)',
    account_info: 'Account Info',
    order_num: 'Payment Count',
    money_num: 'Payment Amount',
    addAccount: 'Add Account',
    editAccount: 'Edit Account',
    gcash_groups: 'Groups',
    accountInfo: ' Account Info',
    basic: 'Basic Info',
    collectionLog: 'Collection Bill',
    paymentLog: 'Payment Bill',
    smsLog: 'SMS Bill',
    actionLog: 'Operation Log',
    ref_num: 'Only Order',
    pay_type: 'Type',
    collection: 'Collection',
    payment: 'Payment',
    textMessage: 'Text Message',
    from_name: 'Payment Account',
    to_name: 'Collection Account',
    money: 'Payment',
    messages: 'Callback Source',
    duanxin: 'SMS Messages',
    open_date: 'Date',
    open_time: 'Time',
    status: 'Status',
    note: 'Remarks',
    batchDel: 'Batch Delet',
    batchBulk: 'Batch Transfer',
    isDetele: 'Whether to permanently delete the above accounts',
    formPhone: 'Transfer Out Account',
    toPhone: 'To Phone',
    phone: 'Transfer phone',
    groupManagement: 'Group Management',
    groupName: 'Group Name',
    openOnePay: 'Transfer Accounts',
    balanceQuery: 'Batch Balance Query',
    batchLogin: 'Batch Login',
    upExcel: 'Excel batch upload of accounts',
    smsId: 'SMS ID',
    wait: 'To be transferred',
    fail: 'Fail',
    success: 'Success',
    twice: 'Secondary verification successful',
    ordinaryTransfer: 'Ordinary Transfer',
    bankTransfer: 'Bank Transfer',
    bank_name: 'Bank Name',
    bank_code: 'Bank Code',
    dst_accno: 'Bank Accounts',
    dst_accname: 'Bankcard Account Name',
    grouping: 'Batch Grouping',
    all_group: 'Whether all the above accounts are transferred to this group',
    code: '（Code）',
    content: 'Content',
    uploader: 'Upload Excel File',
    invite_login: 'Invite Login',
    bank_co: 'Bank Code',
    sign_up: 'Sign Up',
    invite_up: 'Invite up',
    batch_up: 'Batch up',
    account: 'Online Account',
    check: 'Bill',
    gathering: 'Collection',
    anotherPay: 'Pay for another',
    withdrawal: 'Manual withdrawal',
    last: 'Last Call',
    daily_limit: 'Daily Payment Limit',
    monthly_limit: 'Monthly Receipt Limit',
    balance_limit: 'Balance limit',
    team: 'Team',
    login: 'Login OTP authentication'
  },
  payee: {
    info: 'Global payments',
    paymentType: 'Payee account type',
    type1: 'Personal',
    type2: 'Enterprise',
    area: 'Region where the receiving account is located',
    currency: 'Payment currency',
    paymentMethod: 'Payment method',
    upstreamAmount: 'Received amount',
    address: 'Payee address',
    feeType: 'Fee type',
    title1:
      'International bank transfer method, please provide: SWIFT number and bank account number',

    title4:
      'Local bank transfer method, please provide: local path clearing number (or SWIFT number), bank account number',
    title2:
      'Time limit: Conventional processing time limit is 0-7 working days (if encountering factors such as compliance review, technical maintenance, bank failure, force majeure, etc., there may be some delays)',
    title3:
      'Time limit: Conventional processing time limit is 0-3 working days (if encountering factors such as compliance review, technical maintenance, bank failure, force majeure, etc., there may be some delays)'
  },
  appSoftware: {
    search: 'Software Search',
    name: 'Software Name',
    type: 'Software Classification',
    order: 'Product Received',
    download: 'Install',
    noapp: 'The current tag does not have application software.',
    edit: 'Software Details',
    sort: 'Ranking Weight',
    status: 'Plugin Status',
    tag: 'Plugin Type',
    apply: 'Application Tag',
    classify: 'Sort Label',
    inactive: 'Inactive',
    active: 'Active',
    pendingBalance: 'Outstanding Deposit',
    ordernumber: 'order number',
    upstream_ordernumber: 'Upstream Order Number',
    amount: 'Amount',
    before_balance: 'Before Balance',
    after_balance: 'After Balance',
    balanceStatus: 'Balance Status',
    add: 'Add money',
    deduct: 'Deduct money',
    cause: 'Cause',
    deposit_balance: 'Outstanding Deposit',
    payout_balance: 'Pending Payouts',
    appInfo: 'Channel Info',
    fundInfo: 'Fund Details',
    payoutBalance: 'Pending Payout Balance',
    action: 'Settlement Payment Type',
    setting: 'Discard Cause setting',
    create: 'Create Reason For Abandonment',
    label: 'Label',
    value: 'Value',
    actionDetail: 'Ant Order Operation',
    file_url: 'Complete Order Transfer Screenshot',
    ant_status: 'Desired State',
    order_status: 'Pay For Order Status',
    reject: 'Reject',
    ant_action: 'Ant Action',
    picture: 'View Picture',
    finish: 'Payment Completion',
    abandon: 'Discard Order',
    ant_order_no: 'Bank Order Number',
    payment: 'Platform Account',
    approval: 'Approval Operation',
    go: 'Pass',
    padding: 'Wait Order',
    today_deposit_time: 'Deposit Inquiry Time'
  },
  card: {
    user_name: 'User Name',
    name: 'Card Cccount',
    cardManager: 'Card Manager',
    balance: 'Balance',
    transaction: 'Transaction Volume',
    addCard: 'Add Card Account',
    config: 'Card Account Config',
    relevance: 'Relevance Account',
    account: 'Account Product',
    accountName: 'Account',
    successRate: 'Success Rate',
    count: 'Count',
    balanceList: 'Balance',
    increaseBalance: 'Increase Balance',
    relevanceAccount: 'Relevance Account',
    balanceChange: 'Balance change',
    cardName: 'Balance changes',
    money: 'Amount',
    operate: 'Operate',
    add: 'Increase',
    reduce: 'Reduce'
  },
  sms: {
    sms_account: 'SMS Account',
    merchant_balance: 'Merchant Balance',
    sms_logs: 'SMS logs',
    account: 'Account',
    status: 'Status',
    enable: 'Enable',
    noenable: 'No Enable',
    balance: 'Balance',
    gift_balance: 'Gift Balance',
    merchant_no: 'Merchant No',
    name: 'Name',
    sms_balance: 'SMS Balance(USDT)',
    sms_balanc: 'SMS Balance',
    sms_id: 'SMS ID',
    send_mobile: 'Send Mobile',
    success: 'Success',
    fail: 'Fail',
    sms_message: 'SMS Message',
    send_time: 'Send Time',
    addsmsAccount: 'Add SMS Account',
    editsmsAccount: 'Edit SMS Account',
    ref_no: 'Ref No',
    amount: 'Amount',
    remark: 'Remark',
    ip_address: 'IP Address',
    account_number: 'Account Number',
    password: 'Password',
    price: 'Price(USDT)',
    send_status: 'Send Status',
    send_state0: 'Successfully sent',
    send_state1: 'Not sent',
    send_state2: 'Sending',
    send_state3: 'Fail in send',
    delivery_status: 'Delivery Status',
    delivery_status0: 'Not reporting',
    delivery_status1: 'Sent but not delivered',
    delivery_status2: 'Delivery failed',
    delivery_status3: 'Delivery successful',
    delivery_status4: 'Delivery timeout',
    delivery_status5: 'unknown',
    smsSwitch: 'SMS Switch',
    failed_sent: 'Failed sent',
    success_rate: 'Success rate(%)',
    success_sent: 'Success sent',
    total_cost: 'Total cost',
    total_sent: 'Total sent'
  }
}
